<template>

    <section id="agenda">
        <h2 style="font-size: 1.5rem;">Reservationer i dag</h2>
        <ul class="list">
            <li v-for="b in bookings" :key="b.id">
                <h3>
                    <router-link :to="`/booking/${ b.id }`">
                        {{ new Date(b.start).getHours() }}:{{ prettyZero( new Date(b.start).getMinutes() ) }}
                        <span> - </span> 
                        {{ new Date(b.end).getHours() }}:{{ prettyZero( new Date(b.end).getMinutes() ) }}
                        {{ b.title }}
                    </router-link>
                </h3>
                <p>
                    <strong>{{ b.resource_name }}</strong> 
                    <span style="opacity: .5;"> {{ b.resource_admin_unit.name }}</span>
                </p>
                <p v-if="b.description" v-html="truncateText(b.description)"></p>
            </li>
        </ul>
        <p v-if="bookings.length < 1">
            Der er ingen lokaler reserveret i dag
        </p>
    </section>

</template>

<script>

    import axios from '../../utils/Http.js'
    import { dateJs2django, leadZero, sortBookings } from '../../utils/Filters.js'
    
    export default {
        
        data: function() {
            return {
                bookings: [],
                today: dateJs2django( new Date() ),
                tonight: dateJs2django( new Date(new Date().setHours(23,59)) )
            }
        },
        methods: {
            fetchBookings: function() {
                axios({
                    method: 'get',
                    url: `/booking/booking/?from=${ encodeURIComponent(this.today) }&to=${ encodeURIComponent(this.tonight) }&status=1`,
                    headers: {
                        'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                    }
                })
                .then(res => {
                    let b_list = res.data
                    this.bookings = sortBookings(b_list)
                })
                .catch(err => console.log(err))
            },
            prettyZero: function(x) {
                return leadZero(x)
            },
            truncateText: function(txt) {
                const l = txt.length
                if (l < 140) {
                    return txt
                } else {
                    return txt.substring(0,140) + '&hellip;'
                }
            }
        },
        created: function() {
            this.fetchBookings()
        }
        
    }

</script>

<style lang="scss">

    #agenda {

        .list li {
            margin: 1rem 0;
        }
        h3 {
            margin: 0;
        }
        p {
            margin: 0;
        }
    }

</style>
